<template>
    <div class="relative overflow-hidden border border-slate-200 dark:border-slate-800 rounded-lg p-4 bg-white dark:bg-slate-800/60 shadow-xs flex flex-col justify-between">
        <i v-if="icon" 
            :class="[ 'pi', icon, isNumber ? '-bottom-3 -left-3 ml-5' : '-bottom-3 -right-3 mr-3']" 
            class="absolute top-3 bottom-0  h-full flex items-center text-[75px] 
                   leading-none opacity-5 text-slate-900 dark:text-white pointer-events-none 
                   select-none z-0 overflow-hidden transition-all duration-300">                   
        </i>

        <div class="relative z-10 flex flex-col">
            <!-- :class="isNumber ? 'items-end text-right' : 'items-start text-left'"> -->
            <span class="text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                {{ title }}
            </span>
        </div>
        
        <div class="relative z-10 mt-3 flex flex-col"
            :class="isNumber ? 'items-end text-right' : 'items-start text-left'">
            <div class="text-4xl -mt-3 font-bold text-slate-800 dark:text-white">
                {{ formattedValue }}
            </div>
            <div v-if="subtitle" class="text-xs text-slate-400 mt-1">
                {{ subtitle }}
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
  
    const props = defineProps({
           title   : String
         , subtitle: String
         , icon    : String
         , format  : String
         , value   : [Number, String]
    })
    
    // Check if number or string
    const isNumber = computed(() => {
        return typeof props.value === 'number'
    })
    const formattedValue = computed(() => {
        if (props.value === undefined || props.value === null) return '-'
        if (props.format === 'currency') {
            return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(props.value)
        }
        if (props.format === 'number') {
            return new Intl.NumberFormat('id-ID').format(props.value)
        }
        return props.value
    })
</script>